// 倒计时
function getRandomNum(min, max) {
  return Math.floor(Math.random() * (max - min)) + min;
}

let endTimeG;

function cutDownTime() {
  let nowTime = new Date();
  let endTime = new Date(endTimeG);

  let leftTime = endTime.getTime() - nowTime.getTime();
  if (leftTime < 0) {
    setupNewCountdown();
    leftTime = 0;
  }
  let leftH = Math.floor((leftTime / (1000 * 60 * 60)) % 24),
    leftM = Math.floor((leftTime / (1000 * 60)) % 60),
    leftS = Math.floor((leftTime / 1000) % 60);
  leftH = leftH >= 10 ? leftH : "0" + leftH;
  leftM = leftM >= 10 ? leftM : "0" + leftM;
  leftS = leftS >= 10 ? leftS : "0" + leftS;

  return {
    hour: leftH,
    minute: leftM,
    second: leftS,
  };
}
function setupNewCountdown() {
  const randomHour = getRandomNum(1, 9);
  const currentTime = new Date();
  endTimeG = currentTime.setHours(currentTime.getHours() + randomHour);
}
let intervalId;

function getCutDownTime() {
  setupNewCountdown();
  if (intervalId) clearInterval(intervalId);
  intervalId = setInterval(function () {
    let cutDownTimeText = cutDownTime();
    $(".sp_top_cut_down .sp_left_view .sp_hour").html(cutDownTimeText.hour);
    $(".sp_top_cut_down .sp_left_view .sp_minute").html(cutDownTimeText.minute);
    $(".sp_top_cut_down .sp_left_view .sp_second").html(cutDownTimeText.second);
  }, 1000);
}

getCutDownTime();

let swiper = new Swiper("#sp-swiper", {
  autoplay: true,
  autoplay: {
    disableOnInteraction: false,
  },
  spaceBetween: 15,
  slidesPerView: "auto",
  loop: true,
  centeredSlides: true,
  pagination: {
    el: ".pagination1",
    type: "bullets",
    clickable: true,
  },
});

let prods = window.product;
function getCur(){
  console.log(prods,'prods')
  let color = $('#sp-color div.active').attr('data-val')
  console.log(color,'color')
  return prods.filter(item=> item.option1 == color)[0]
}
function changePrice(){
  let num = $('#calcNumber').val()
  console.log(getCur(),'getCur().price')
  let price = (getCur().price)
  let compare = (getCur().compare_at_price)
  // if(num == 1){
  //   price = (getCur().price * num / 100).toFixed(2)
  // }else if(num == 2){
  //   price = (getCur().price * num / 100 * 0.95).toFixed(2)
  // }else if(num == 3){
  //   price = (getCur().price * num / 100 * 0.9).toFixed(2)
  // }else {
  //   price = (getCur().price * num / 100 * 0.85).toFixed(2)
  // }
  // price = (price + '').replace('.', ',')
  // compare = (compare + '').replace('.', ',')
  $('.product-part .price-group .sp_price1').html(price)
  $('.product-part .price-group .sp_price2').html(compare)
  let off_font = 100 - Math.ceil(getCur().price / getCur().compare_at_price * 100)
  $(".product-part .sp-off span").html(off_font);
}
$(".reduce").click(function () {
  let input = $(this).siblings("input")[0];
  let num = Number(input.value) - 1;
  if (num > 0) {
    input.value = num;
  }
});
$(".add").click(function () {
  let input = $(this).siblings("input")[0];
  let num = Number(input.value) + 1;
  input.value = num;
});


  $('.buyNow').click(function(){
    let num = $(this).parent().find('.addGroup input').val()
    let id = $(this).attr('data-id')
    window.location.href = '/cart/' + id + ':' + num
  })

// $('.buyNow').click(function(){
// //   window.location.href = '/cart/' + id + ':' + num 
//   // var items = [{
//   //   quantity: $('#calcNumber').val(), // 数量
//   //   variant_id: getCur().id, // 子商品id
//   //   note: '', // 备注
//   //   }]
//   //   $.post('/api/checkout/order', {
//   //       line_items: items,
//   //       refer_info: { source: 'buy_now' }
//   //   }, function (ret) {
//   //       if (ret.state === 'success') {
//   //           return (window.safeHref = '/checkout/' + ret.data.order_token + '?step=contact_information');
//   //       } else {
//   //           $.toast.show({
//   //               content:
//   //                   {
//   //                       '30003': "Some items have been removed, please re-order",
//   //                       'line_items_variant_withdraw': "Some items have been sold out, please re-order",
//   //                       'line_items_variant_sold_out': "Some items are not in stock, please re-order"
//   //                   }[ret.state] || ret.errors[0] || "Some items information has been updated, please re-order"
//   //           });
//   //       }
//   //   });
// })

  $(function () {
    $("#root").css("zoom", "normal");
    let scale = document.body.clientWidth / 1080;
    $("#root").css("zoom", scale);

    window.addEventListener(
      "resize",
      (function () {
        var timer;
        return function () {
          if (timer) clearTimeout(timer);
          timer = setTimeout(function () {
            $("#root").css("zoom", "normal");
            let scale = document.body.clientWidth / 1080;
            $("#root").css("zoom", scale);
          }, 100);
        };
      })()
    );
  });

  function lazyLoadImages() {
    // 懒加载
    const images = document.querySelectorAll(".lazy-load"); // 获取所有需要懒加载的图片
    const config = {
      rootMargin: "0px 0px 1300px 0px",
      threshold: 0,
    };

    const lazyLoadObserver = new IntersectionObserver(function (
      entries,
      observer
    ) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          // 当图片进入视口时
          const image = entry.target;
          const dataSrc = image.getAttribute("data-src");
          image.src = dataSrc; // 将data-src属性的值设置为图片的实际地址
          lazyLoadObserver.unobserve(image); // 停止观察该图片
        }
      });
    },
    config);

    images.forEach(function (image) {
      lazyLoadObserver.observe(image); // 开始观察每个图片
    });
  }

  function preloadImages(imageArray) {
    // 预加载
    // 检查数组数据结构
    if (Array.isArray(imageArray[0])) {
      // 处理二维数组
      imageArray.forEach((subArray) => {
        subArray.forEach((url) => {
          const img = new Image();
          img.src = url;
        });
      });
    } else {
      // 处理一维数组
      imageArray.forEach((url) => {
        const img = new Image();
        img.src = url;
      });
    }
  }

  document.addEventListener("DOMContentLoaded", function () {
    lazyLoadImages();

    preloadImages(spImgList);

    // // 找到所有跳转套餐的锚点链接
    // var links = document.querySelectorAll('a[href^="#shopping"]');
    // links.forEach(function (link) {
    //   link.addEventListener("click", function (event) {
    //     event.preventDefault(); // 阻止默认的跳转行为
    //     // var targetElement = document.getElementById('shopping');
    //     // if (targetElement) {
    //     //     targetElement.scrollIntoView({ behavior: 'smooth' });
    //     // } // 方式一
    //     const targetElement = document.getElementById("shopping"); // 获取跳转目标节点
    //     const offsetTop = targetElement.offsetTop;
    //     window.scroll({
    //       top:
    //         offsetTop * $("div#root").css("zoom") +
    //         -255 * $("div#root").css("zoom"),
    //       behavior: "smooth", // 使用 smooth 实现平滑滚动
    //     }); // 方式二
    //   });
    // });





        // 找到所有跳转套餐的锚点链接
    var links = document.querySelectorAll('a[href^="#shopping"]');
    links.forEach(function (link) {
      link.addEventListener("click", function (event) {
        event.preventDefault(); // 阻止默认的跳转行为
        // var targetElement = document.getElementById('shopping');
        // if (targetElement) {
        //     targetElement.scrollIntoView({ behavior: 'smooth' });
        // } // 方式一
        const targetElement = document.getElementById("shopping"); // 获取跳转目标节点
        const offsetTop = targetElement.offsetTop;
        window.scroll({
          top: offsetTop * $("div#root").css("zoom") - 245 * $("div#root").css("zoom") ,
          behavior: "smooth", // 使用 smooth 实现平滑滚动
        }); // 方式二
      });
    });
  });

  // IOS字体多了间距的处理 给节点添加 sp_system 类名
  // 判断当前用户是安卓端还是iOS端
  var userAgent = navigator.userAgent || navigator.vendor || window.opera;
  var isAndroid = /android/i.test(userAgent);
  var isIOS = /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream;
  var isPC = !isAndroid && !isIOS && !/Iron/.test(userAgent); // 添加了对 "Iron" 关键词的判断

  if (isAndroid) {
    console.log("Android");
  } else if (isIOS) {
    console.log("iOS");
  } else if (isPC) {
    console.log("PC");
  } else {
    $(".sp_system").css("letter-spacing", "-4px");
  }



let spImgList = [
  "https://cdn.shopifycdn.net/s/files/1/0762/7253/3814/files/3ad3c4ca3bd06f391a8858cffd00a81b.png",
  "https://cdn.shopifycdn.net/s/files/1/0762/7253/3814/files/a7a859192f2d7e0e80c7e2d7e819e904.png",
  "https://cdn.shopifycdn.net/s/files/1/0762/7253/3814/files/335590b0f9be70275bdb9bebfe74249e.png",
  "https://cdn.shopifycdn.net/s/files/1/0762/7253/3814/files/33a169405ae4e65c263640cd1ac52fa3.png",
];

$(".option").click(function () {
  $(this).siblings().removeClass("active");
  $(this).addClass("active");
  // style选项
  let colorOptions = $("#sp-color .option.active").index();
  if (colorOptions == 0) {
    swiper.slideTo(2);
  } else if (colorOptions == 1) {
    swiper.slideTo(1);
  }
  changePrice()
});

$('#sp-color div').click(function(){
  console.log(222222222222)
  let index = $(this).index()
  $('.option-img').attr('src', spImgList[index])
})
   
